import { temAcesso } from '@/shared/auth/temAcesso'

const ItemDespesa = () => import('./ItemDespesa.vue')

export default {
    path: 'itensdespesa/:despesaItemId',
    name: 'DespesasGerais_Demandantes_ItensDespesa_Detalhar',
    component: ItemDespesa,
    beforeEnter(to, from, next) {
        if (temAcesso('DESP-GERAIS-DEMAN-00')) {
            next()
        }
    } 
}